import { useFieldsStyles } from 'assets/styles/common';
import { ShowRecordButton } from 'components';
import { FC } from 'react';
import { Datagrid, DateField, List, ListProps, TextField } from 'react-admin';

import { CheckupsFilter } from './CheckupsFilters';

export const CheckupsList: FC<ListProps> = (props) => {
  const { textField } = useFieldsStyles();
  return (
    <List {...props} filters={<CheckupsFilter />} bulkActionButtons={false}>
      <Datagrid>
        <TextField source="id" sortable={false} />
        <DateField source="createdAt" sortable={false} />
        <TextField source="name" className={textField} sortable={false} />
        <ShowRecordButton />
      </Datagrid>
    </List>
  );
};
